import { render } from "./DashboardRealtor.vue?vue&type=template&id=85f69d8e"
import script from "./DashboardRealtor.vue?vue&type=script&lang=js"
export * from "./DashboardRealtor.vue?vue&type=script&lang=js"

import "./DashboardRealtor.vue?vue&type=style&index=0&id=85f69d8e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__